/* Aquelia storefront behaviour: buy box bundles + subscription plans, add-ons, sticky bar, gallery, calculator,
   delivery ETA, cart upsell. Plain deferred script; no dependencies. Uses Shopify.actions.updateCart (Horizon's cart
   contract) with an AJAX fallback. Lines: {id, q, plan?} where plan is a selling plan id. */
(function () {
  'use strict';

  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency });
  var fmt0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  function money(cents) { return fmt.format(cents / 100); }
  function dollars(v) { return fmt0.format(Math.round(v)); }

  async function addLines(lines) {
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      var res = await actions.updateCart(
        { lines: lines.map(function (l) {
          var o = { merchandiseId: String(l.id), quantity: l.q };
          if (l.plan) o.sellingPlanId = String(l.plan);
          return o;
        }) },
        { event: { context: 'product' } }
      );
      if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      if (typeof actions.openCart === 'function') actions.openCart();
      return;
    }
    var r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map(function (l) {
        var o = { id: l.id, quantity: l.q };
        if (l.plan) o.selling_plan = l.plan;
        return o;
      }) })
    });
    if (!r.ok) {
      var j = {};
      try { j = await r.json(); } catch (e) {}
      throw new Error(j.description || 'We couldn’t add that to your cart. Please try again.');
    }
    window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  }
  window.AqueliaAddLines = addLines;

  /* Horizon scrolls .page-wrapper rather than the window, so listen to both. */
  function onAnyScroll(fn) {
    var wrap = document.querySelector('.page-wrapper');
    var raf;
    function tick() { cancelAnimationFrame(raf); raf = requestAnimationFrame(fn); }
    window.addEventListener('scroll', tick, { passive: true });
    if (wrap) wrap.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    fn();
  }

  /* ---------- Buy box ---------- */
  function initBuy(form) {
    if (form.dataset.aqReady) return;
    form.dataset.aqReady = '1';
    var root = form.closest('.aq-buy') || document;
    var totalEl = root.querySelector('[data-aq-total]');
    var stickyPrice = document.querySelector('[data-aq-sticky-price]');
    var errorEl = root.querySelector('[data-aq-error]');
    var btn = root.querySelector('[data-aq-buybtn]');

    /* A setup the shopper picked on the homepage (?setup=2) arrives selected. */
    var wanted = new URLSearchParams(window.location.search).get('setup');
    if (wanted) {
      var radio = form.querySelector('input[name="aq-tier"][value="' + wanted.replace(/[^0-9]/g, '') + '"]');
      if (radio) radio.checked = true;
    }

    /* Subscription tier: the chosen plan rewrites the tier's items and total. */
    function syncPlan() {
      var tier = form.querySelector('[data-aq-subtier] input[name="aq-tier"]');
      var plan = form.querySelector('input[data-aq-plan]:checked');
      if (!tier || !plan) return;
      var base = JSON.parse(tier.dataset.base || '[]');
      base.push({ id: parseInt(tier.dataset.subVariant, 10), q: 1, plan: parseInt(plan.value, 10) });
      var total = parseInt(tier.dataset.baseTotal || '0', 10) + parseInt(plan.dataset.price || '0', 10);
      tier.dataset.items = JSON.stringify(base);
      tier.dataset.total = String(total);
      var sp = form.querySelector('[data-aq-subprice]');
      if (sp) sp.textContent = money(total);
    }

    function selection() {
      var lines = [];
      var total = 0;
      var tier = form.querySelector('input[name="aq-tier"]:checked');
      if (tier) {
        JSON.parse(tier.dataset.items || '[]').forEach(function (it) { lines.push({ id: it.id, q: it.q, plan: it.plan }); });
        total += parseInt(tier.dataset.total || '0', 10);
      }
      form.querySelectorAll('input[data-aq-addon]:checked').forEach(function (cb) {
        lines.push({ id: parseInt(cb.value, 10), q: 1 });
        total += parseInt(cb.dataset.price || '0', 10);
      });
      return { lines: lines, total: total };
    }

    function update(e) {
      if (e && e.target && e.target.matches && e.target.matches('input[data-aq-plan]')) {
        var subRadio = form.querySelector('[data-aq-subtier] input[name="aq-tier"]');
        if (subRadio) subRadio.checked = true;
      }
      syncPlan();
      var s = selection();
      if (totalEl) totalEl.textContent = money(s.total);
      if (stickyPrice) stickyPrice.textContent = money(s.total);
      var bt = btn && btn.querySelector('[data-aq-btn-total]');
      if (bt) bt.textContent = money(s.total);
    }

    form.addEventListener('change', update);
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var s = selection();
      if (!s.lines.length) return;
      if (errorEl) errorEl.textContent = '';
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      try {
        await addLines(s.lines);
      } catch (err) {
        if (errorEl) errorEl.textContent = err.message;
      } finally {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }
    });
    update();

    var sticky = document.querySelector('[data-aq-sticky]');
    if (sticky && btn) {
      onAnyScroll(function () {
        var past = btn.getBoundingClientRect().bottom < 0;
        if (sticky.classList.contains('is-visible') !== past) {
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        }
      });
      var sbtn = sticky.querySelector('[data-aq-sticky-btn]');
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-aq-track]');
    var thumbs = root.querySelectorAll('[data-aq-thumb]');
    if (!track) return;
    var slides = track.children;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    }, { passive: true });
  }

  /* ---------- Cost calculator (whole dollars, whole numbers) ---------- */
  function initCalc(root) {
    var range = root.querySelector('[data-aq-gal]');
    var bottled = parseFloat(root.dataset.bottled || '1.25');
    var perGal = parseFloat(root.dataset.filter || '0.015');
    function out(k, v) { var el = root.querySelector('[data-out="' + k + '"]'); if (el) el.textContent = v; }
    function update() {
      var g = parseFloat(range.value);
      var yearGal = g * 365;
      var b = Math.round(yearGal * bottled);
      var a = Math.round(yearGal * perGal);
      out('gal', g.toFixed(1) + ' gal');
      out('year', Math.round(yearGal).toLocaleString('en-US') + ' gallons');
      out('bottled', dollars(b));
      out('aquelia', dollars(a));
      out('save', dollars(b - a));
      out('bottles', Math.round(yearGal * 3.785 / 0.5).toLocaleString('en-US'));
      range.setAttribute('aria-valuetext', g.toFixed(1) + ' gallons per day');
    }
    range.addEventListener('input', update);
    update();
  }

  /* ---------- Delivery estimate (business days) ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function initEta(el) {
    var min = parseInt(el.dataset.min || '3', 10), max = parseInt(el.dataset.max || '8', 10);
    var o = { weekday: 'short', month: 'short', day: 'numeric' };
    var now = new Date();
    var t = el.querySelector('[data-aq-eta-text]');
    if (t) t.textContent = addBusinessDays(now, min).toLocaleDateString('en-US', o) + ' – ' + addBusinessDays(now, max).toLocaleDateString('en-US', o);
    el.hidden = false;
  }

  /* ---------- Cart drawer upsell (delegated: the drawer re-renders) ---------- */
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-aq-upsell]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.setAttribute('aria-busy', 'true');
    try { await addLines([{ id: parseInt(b.dataset.aqUpsell, 10), q: 1 }]); }
    catch (err) { b.textContent = 'Try again'; }
    finally { b.disabled = false; b.removeAttribute('aria-busy'); }
  });

  function init() {
    document.querySelectorAll('[data-aq-buy]').forEach(initBuy);
    document.querySelectorAll('[data-aq-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-aq-calc]').forEach(initCalc);
    document.querySelectorAll('[data-aq-eta]').forEach(initEta);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
